import axios from './api'

export function getCategoryNew (data) {
  return axios({
    url: '/abpi/category/v1/categoryList',
    method: 'POST',
    data
  })
}

// export function getGoodsDtoList (data) {
//   return axios({
//     url: '/abpi/goods/v1/goodsList',
//     method: 'POST',
//     data
//   })
// }

export default {
  getCategoryNew
  // getGoodsDtoList
}
